import {CloseButton, EditButton} from './../Button/Button';

import './Palette.css';

const Palette = (props) => {

    const color = props.style.color;
    const className = ( typeof props.className !=='undefined' ? props.className + '' : '' ) + (props.transition.state ? props.transition.color === color ? 'transition-larger' : 'transition-smaller' : '');
    return(
        <div 
            className={`palette color ${className}`}
            /*onClick={() => props.callback(color)}*/
            style={{backgroundColor: '#'+color, width: props.style.width, left: props.style.left, zIndex: props.style.zIndex}}>
            <div className='bottom-ui-container'>
                {typeof props.removeColor !== 'undefined' ? <CloseButton callback={() => props.removeColor(color)}/> : ''}
                {typeof props.editColor !== 'undefined' ? <EditButton callback={() => props.editColor(color)}/> : ''}
            </div>
        </div>
    );
}

export default Palette;